import { head } from 'lodash/fp';

import { Country, FormValues } from '../../types';
import { FIELD_NAMES } from '../../constants';
import getCountriesBySearch from '../get-countries-by-search';

type ProcessDestinationParams = {
  countries: Country[];
  destinationLocation?: string;
  widgetValuesFromQuery: Partial<Record<keyof FormValues, string>>;
};

const getDestinationFormValuesFromQuery = ({
  countries,
  destinationLocation,
  widgetValuesFromQuery,
}: ProcessDestinationParams) => {
  const whereField = FIELD_NAMES.WHERE as keyof FormValues;
  const whereSearchTerm = destinationLocation || (widgetValuesFromQuery[whereField] as string);
  const whereSearchTermWithoutHyphen = whereSearchTerm?.replace('-', ' ');
  const destinationCountry = head(getCountriesBySearch(countries, whereSearchTermWithoutHyphen));

  return destinationCountry
    ? {
        [FIELD_NAMES.WHERE]: destinationCountry.label,
        [FIELD_NAMES.DESTINATIONS]: destinationCountry.value,
      }
    : {};
};

export default getDestinationFormValuesFromQuery;
